var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.65002L6.57501 12.075C5.10666 13.5435 4.10674 15.4144 3.70168 17.4512C3.29662 19.488 3.50462 21.5991 4.29937 23.5177C5.09413 25.4362 6.43994 27.0761 8.16663 28.2298C9.89332 29.3835 11.9233 29.9993 14 29.9993C16.0767 29.9993 18.1067 29.3835 19.8334 28.2298C21.5601 27.0761 22.9059 25.4362 23.7006 23.5177C24.4954 21.5991 24.7034 19.488 24.2983 17.4512C23.8933 15.4144 22.8934 13.5435 21.425 12.075L14 4.65002ZM14 0.40802L23.546 9.95402C25.434 11.842 26.7197 14.2475 27.2406 16.8662C27.7615 19.485 27.4942 22.1994 26.4724 24.6662C25.4506 27.133 23.7202 29.2414 21.5002 30.7248C19.2801 32.2081 16.67 32.9999 14 32.9999C11.33 32.9999 8.71988 32.2081 6.49983 30.7248C4.27977 29.2414 2.54944 27.133 1.52765 24.6662C0.50586 22.1994 0.238506 19.485 0.759393 16.8662C1.28028 14.2475 2.56601 11.842 4.45401 9.95402L14 0.40802ZM14 27V12C15.9891 12 17.8968 12.7902 19.3033 14.1967C20.7098 15.6032 21.5 17.5109 21.5 19.5C21.5 21.4891 20.7098 23.3968 19.3033 24.8033C17.8968 26.2098 15.9891 27 14 27Z",
    fill: "#4FC2D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGout);
export default __webpack_public_path__ + "static/media/gout.49a43f78c3d188be5eac7ba79a429cd3.svg";
export { ForwardRef as ReactComponent };